<template>
    <div class="w-11/12 sm:w-3/5 md:w-2/3 xl:w-2/5 xxl:w-1/3 m-auto mb-12">
        <a href="/">
            <img src='assets/img/nesst-logo.svg' alt="NESst-logo" class="w-20 md:w-32 py-6 text-center m-auto">
        </a>
        <div class="questionnaire-wrapper w-full mx-auto flex flex-col bg-white p-4 sm:p-6 md:px-10">
            <loader v-if="loading" class="m-auto"/>

            <div v-else>
                <div class="flex items-center justify-center mb-3">
                    <span
                            @click="tab = 'questionnaires'"
                            :class="{'border-b': tab === 'questionnaires'}"
                            class="cursor-pointer border-darkGreen-200 hover:border-darkGreen-100 mr-2">Questionnaires</span>
                    <span
                            @click="tab = 'mentors'"
                            :class="{'border-b': tab === 'mentors'}"
                            class="cursor-pointer border-darkGreen-200 hover:border-darkGreen-100">Mentors</span>
                </div>

                <template v-if="tab === 'questionnaires'">
                    <h2 class="text-xl sm:text-2xl lg:text-3xl font-bold text-muted-500 text-center mb-5">My questionnaires</h2>
                    <template v-if="questionnaires.length">
                        <div class="flex items-center justify-between font-bold text-muted-500 mb-4 px-4">
                            <span>Questionnaire</span>
                            <span>Taken on</span>
                        </div>
                        <a :href="`scores?token=${shareToken}&q=${questionnaire.name}&s=${questionnaire.session}`"
                           class="bg-darkGreen-200 hover:bg-darkGreen-100 rounded-full shadow flex items-center justify-between text-white mb-4 px-4 py-3"
                           v-for="questionnaire of questionnaires">
                            <h3 class="font-bold">{{ questionnairesList[questionnaire.name] }}</h3>
                            <span>{{ questionnaire.date | sessionDate }}</span>
                        </a>
                        <div class="pt-10 text-center">
                            <h3 class="text-lg lg:text-xl font-bold text-muted-500 mb-5">Take another stage assessment test</h3>
                            <a href="questionnaire?q=stage" class="inline-block py-3 px-10 tracking-wider text-lg sm:text-xl font-bold text-white bg-darkGreen-200 hover:bg-darkGreen-100 rounded-full">GET STARTED</a>
                        </div>
                    </template>
                    <div v-else class="text-center">
                        <h3 class="text-lg sm:text-xl lg:text-2xl font-bold text-muted-500 mb-5">No questionnaires taken yet.</h3>
                        <a href="questionnaire?q=stage" class="inline-block py-3 px-10 tracking-wider text-lg sm:text-xl font-bold text-white bg-darkGreen-200 hover:bg-darkGreen-100 rounded-full">GET STARTED</a>
                    </div>
                </template>

                <template v-if="tab === 'mentors'">
                    <h2 class="text-xl sm:text-2xl lg:text-3xl font-bold text-muted-500 text-center mb-5">My mentors</h2>
                    <div v-if="mentors.length" class="mb-6">
                        <div class="flex items-center mb-4"
                             v-for="mentor of mentors">
                            <div class="flex flex-1 items-center justify-between px-4 py-3 bg-darkGreen-200 hover:bg-darkGreen-100 rounded-full shadow text-white font-bold">
                                <span>{{ mentor.name }}</span>
                                <span>{{ mentor.email }}</span>
                            </div>
                            <button @click.stop="openConfirmModal(mentor)" class="p-4 ml-2 rounded-full bg-risk-400 hover:bg-risk-500 text-white">
                                <svg class="fill-current" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"><path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"/></svg>
                            </button>
                        </div>
                    </div>

                    <div>
                        <h3 class="text-lg sm:text-xl lg:text-2xl font-bold text-muted-500 text-center mb-5">Add mentor</h3>
                        <input class="block w-full py-1 sm:py-2 md:py-4 px-3 md:px-6 mb-4 border bg-light-200 border-light-300 rounded-full  focus:outline-none text-muted-500 font-bold focus:bg-transparent focus:border-lightGrey-200"
                               type="text"
                               placeholder="Name *"
                               v-model="mentorName"
                        >
                        <div v-if="errorMessageName" class="w-full px-4 py-3 bg-risk-400 rounded-full text-center text-light-100 mb-4">
                            {{ errorMessageName }}
                        </div>
                        <input class="block w-full py-1 sm:py-2 md:py-4 px-3 md:px-6 mb-4 border bg-light-200 border-light-300 rounded-full  focus:outline-none text-muted-500 font-bold focus:bg-transparent focus:border-lightGrey-200"
                               type="email"
                               placeholder="Email *"
                               v-model="mentorEmail"
                        >
                        <div v-if="errorMessageEmail" class="w-full px-4 py-3 bg-risk-400 rounded-full text-center text-light-100 mb-4">
                            {{ errorMessageEmail }}
                        </div>
                    </div>
                    <div v-if="errorMessage" class="w-full px-4 py-3 bg-risk-400 rounded-full text-center text-light-100 mb-4">
                        {{ errorMessage }}
                    </div>
                    <div class="w-full flex justify-center mt-6">
                        <button type="button"
                                @click="addMentor()"
                                class="inline-block py-3 px-10 tracking-wider text-lg sm:text-xl font-bold text-white bg-darkGreen-200 hover:bg-darkGreen-100 rounded-full">Add</button>
                    </div>
                </template>
            </div>

            <confirm-modal
                v-if="confirmModal"
                :message="confirmMessage"
                @cancel="closeConfirmModal"
                @confirm="removeMentor"/>
        </div>
    </div>
</template>

<script>
    import { firebase, db } from '../../firebase';
    import Loader from '../shared/Loader';
    import * as EmailValidator from 'email-validator/index';
    import ConfirmModal from '../shared/ConfirmModal';

    export default {
        components: {ConfirmModal, Loader},

        data() {
            return {
                loading: true,
                userId: null,
                shareToken: null,
                questionnaires: [],
                mentorEmail: null,
                mentorName: null,
                mentorToRemove: null,
                mentors: [],
                errorMessageEmail: null,
                errorMessageName: null,
                errorMessage: null,
                confirmMessage: null,
                confirmModal: false,
                tab: 'questionnaires'
            }
        },

        computed: {
            questionnairesList() {
                return {
                    startup: 'Start-up Stage',
                    validate: 'Validate Stage',
                    scale: 'Prepare-to-Scale Stage'
                }
            },
        },
        
        methods: {
            validate() {
                const validEmail = !!this.mentorEmail && EmailValidator.validate(this.mentorEmail);
                const validName = this.mentorName;
                const existingEmail = this.mentors.find(el => el.email === this.mentorEmail);

                this.errorMessageEmail = !validEmail ? "This field must be a valid email address!" : null;
                this.errorMessageName = !validName ? "Mentor's name is required!" : null;
                this.errorMessage = existingEmail ? 'Mentor with this email already exists!' : null;

                return !(!validName || !validEmail || existingEmail);
            },
            addMentor() {
                if (!this.validate()) {
                    return;
                }

                this.loading = true;

                const mentors = [...this.mentors];
                const mentor = {
                    name: this.mentorName,
                    email: this.mentorEmail
                };

                mentors.push(mentor);

                db.collection('answers').doc(this.userId).set({meta: {mentors}}, {merge: true}).then(() => {
                    this.mentors.push(mentor);
                    this.mentorName = null;
                    this.mentorEmail = null;
                    this.loading = false;
                }).catch(e => this.errorMessage = e);
            },
            removeMentor() {
                if (!this.mentorToRemove) {
                    return
                }

                this.confirmModal = false;
                this.loading = true;
                const mentors = this.mentors.filter(el => el.email !== this.mentorToRemove.email);

                db.collection('answers').doc(this.userId).set({meta: {mentors}}, {merge: true}).then(() => {
                    this.mentors = mentors;
                    this.mentorToRemove = null;
                    this.confirmMessage = null;
                    this.loading = false;
                }).catch(e => this.errorMessage = e);
            },
            openConfirmModal(mentor) {
                this.mentorToRemove = mentor;
                this.confirmModal = true;
                this.confirmMessage = `Are you sure you want to remove <strong>${mentor.name}</strong> from your mentor list?`
            },
            closeConfirmModal() {
                this.mentorToRemove = null;
                this.confirmModal = false;
                this.confirmMessage = null;
            },
        },

        created() {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    db.collection('answers').doc(user.uid).get().then(doc => {
                        const answers = doc.data();
                        this.userId = user.uid;
                        this.shareToken = answers.meta.shareToken || null;
                        this.mentors = answers.meta.mentors || [];
                        const questionnaires = Object.keys(answers).filter(key => ['startup', 'validate', 'scale'].includes(key));

                        questionnaires.forEach(questionnaire => {
                            const sessions = Object.keys(answers[questionnaire]).sort((a, b) => Number(b) - Number(a));
                            sessions.forEach(session => {
                                this.questionnaires.push({
                                    name: questionnaire,
                                    session,
                                    date: new Date(session * 1000),
                                });
                            });
                        });

                        this.questionnaires = this.questionnaires.sort((a, b) => Number(b.session) - Number(a.session));

                        this.loading = false;
                    });
                } else {
                    window.location.href = 'authenticate?return=dashboard';
                }
            });
        },
    };
</script>
